import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/d-logo.svg";

const ErrorScreen = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className="error-screen">
      <img src={logo} alt="DOMM" className="error-screen__logo" />
      <div className="error-screen__content">
        <p className="error-screen__code">500</p>
        <h1 className="error-screen__title">{t("error.title")}</h1>
        <p className="error-screen__message">
          {message || t("error.message")}
        </p>
        <button className="main-btn" onClick={() => window.location.reload()}>
          {t("error.reload")}
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;
